import { useNavigate } from "react-router";
import { bemCN } from "../../config/bem-classname";
import "./error-page.scss";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import { links } from "../../config/links";

const errorPageCn = bemCN("error-page");

export const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <div className={errorPageCn()}>
      <Button
        onClick={() => navigate(links.stories)}
        color={ButtonColors.crimson}
        size={ButtonSizes.big}
        text="К историям"
      />
    </div>
  );
};
